import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { FetchAllLivreur } from "../CommandesFournisseurs/DataService";

const LivreurDropdown = ({ selectedLivreur, onLivreurChange }) => {
  const [livreurs, setLivreurs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLivreurs = async () => {
      try {
        setLoading(true);
        const response = await FetchAllLivreur();
        setLivreurs(response.data || []);
      } catch (error) {
        console.error("Error fetching livreurs:", error);
        setLivreurs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLivreurs();
  }, []);

  return (
    <Form.Select
      value={selectedLivreur}
      onChange={(e) => onLivreurChange(e.target.value)}
      style={{ width: "auto" }}
      disabled={loading}
    >
      <option value="">
        {loading ? "Chargement..." : "Tous les livreurs"}
      </option>
      {livreurs.map((livreur) => (
        <option key={livreur.id} value={livreur.id}>
          {livreur.nom} {livreur.prenom}
        </option>
      ))}
    </Form.Select>
  );
};

export default LivreurDropdown;